import { render, staticRenderFns } from "./approval-center.vue?vue&type=template&id=6fbf3d44&scoped=true"
import script from "./approval-center.vue?vue&type=script&lang=js"
export * from "./approval-center.vue?vue&type=script&lang=js"
import style0 from "./approval-center.vue?vue&type=style&index=0&id=6fbf3d44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf3d44",
  null
  
)

export default component.exports